import { type ReactNode } from 'react';
import { StatCard } from '@/components/ui/stat-card';
import { RankingCard } from './ranking-card';

type Props = {
  today: number;
  week: number;
  month: number;
  total: number;
  position: number;
  totalApproachers: number;
};

export function ApproacherStatCards(p: Props): ReactNode {
  return (
    <div className="grid grid-cols-2 gap-sm sm:grid-cols-3 md:grid-cols-5">
      <StatCard label="Total" value={p.total} accent />
      <StatCard label="Hoy" value={p.today} />
      <StatCard label="Objetivo semanal" value={p.week} />
      <StatCard label="Este mes" value={p.month} />
      {p.position > 0 && (
        <RankingCard position={p.position} total={p.totalApproachers} />
      )}
    </div>
  );
}
